import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import img2 from "../../assets/images/kawa2.jpg";
import img1 from "../../assets/images/harley.jpg";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRecentPosts } from "../../redux/slices/apiSlice";

export function useLoadRecentPosts() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRecentPosts());
  }, [dispatch]);

  const posts = useSelector((state) => state.posts);
  return posts;
}

export const postsData = [
  { id: "1", platform: "Facebook", file: img2 },
  { id: "12", platform: "Instagram", file: img1 },
];
export const tabs = [
  "RecentPosts",
  "Calendar",
  "Approvals",
  "Accounts",
  "Activity Log",
];
export const singlePostsData = [{ id: "1", platform: "Facebook" }];

export const tableAccountsData = [
  {
    id: 1,
    outletName: "Outlet 1",
    outletCode: "A001",
    franchiseName: "Franchise",
    Account: "57",
    instaId: "57",
    fbId: "57",
    linkindId: "57",
    status: "Success",
  },
];
export const TableHeadersAccounts = [
  { label: "S.No", key: "sNo", index: true },
  { label: "Outlet Name", key: "outletName" },
  { label: "Outlet Code", key: "outletCode" },
  { label: "Franchise name", key: "franchiseName" },
  { label: "Account", key: "Account" },
  { label: "Insta ID", key: "instaId" },
  { label: "Facebook ID", key: "fbId" },
  { label: "Linked ID", key: "linkindId" },
  { label: "Status", key: "status", class: "text-green-600 font-bold" },
];
export const TableHeadersActivityAndApprovalsStyles = [
  { label: "S.No", key: "sNo", index: true },
  { label: "Date & Time", key: "date" },
  {
    label: "Post Preview",
    key: "post",
    type: "link",
    class: "text-blue-500 cursor-pointer",
  },
  { label: "Platforms", key: "platforms" },
  { label: "Outlet Name", key: "outlet" },
  { label: "Requested By", key: "requestedBy" },
  { label: "Status", key: "status", class: "text-green-600 font-bold" },
];

export const TableHeadersActivityStyles = [
  { label: "S.No", key: "sNo", index: true },
  { label: "Date & Time", key: "date" },
  {
    label: "Post Preview",
    key: "post",
    type: "link",
    class: "text-blue-500 cursor-pointer",
  },
  { label: "Platforms", key: "platforms" },
  { label: "Outlet", key: "outlet" },
  { label: "Posted By", key: "requestedBy" },
  { label: "Status", key: "status", class: "text-green-600 font-bold" },
];

export const tableData = [
  {
    id: 1,
    date: "18/02/2025 04:30AM",
    post: "Post 145",
    platforms: "Facebook, Instagram",
    outlet: "Outlet 1",
    requestedBy: "example@gmail.com",
    status: "Success",
  },
];
export const sampleSelectionItems = [
  {
    label: "Business Location 2, New Delhi",
    value: "delhi",
    city: "Delhi",
    zone: "North",
    region: "Urban",
  },
  {
    label: "Business Location 2, Gurgaon",
    value: "gurgaon",
    city: "Gurgaon",
    zone: "North",
    region: "Urban",
  },
  {
    label: "Business Location 2, Noida",
    value: "noida",
    city: "Noida",
    zone: "North",
    region: "Urban",
  },
  {
    label: "Business Location 2, Jaipur",
    value: "jaipur",
    city: "Jaipur",
    zone: "West",
    region: "Urban",
  },
  {
    label: "Business Location 2, Chennai",
    value: "chennai",
    city: "Chennai",
    zone: "South",
    region: "Urban",
  },
];

export const platformOptions = [
  {
    value: "facebook",
    label: "Facebook",
    icon: <FaFacebook className="text-blue-600 text-2xl" />,
  },
  {
    value: "instagram",
    label: "Instagram",
    icon: <FaInstagram className="text-pink-500 text-2xl" />,
  },
  {
    value: "linkedin",
    label: "LinkedIn",
    icon: <FaLinkedin className="text-blue-700 text-2xl" />,
  },
];
export const platformIcons = {
  facebook: <FaFacebook className="text-blue-600 text-2xl" />,
  instagram: <FaInstagram className="text-pink-500 text-2xl" />,
  linkedin: <FaLinkedin className="text-blue-700 text-2xl" />,
};
export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
].map((month) => ({ value: month, label: month }));

export const days = Array.from({ length: 31 }, (_, i) => ({
  value: (i + 1).toString(),
  label: (i + 1).toString(),
}));

export const years = Array.from({ length: 16 }, (_, i) => ({
  value: (2010 + i).toString(),
  label: (2010 + i).toString(),
}));

export const accountsTableHeaders = [
  {
    label: "S.No",
    key: "id",
  },
  {
    label: "Outlet Name",
    key: "outletName",
  },
  {
    label: "Outlet Code",
    key: "outletCode",
  },
  {
    label: "Franchise name",
    key: "franchiseName",
  },
  {
    label: "Account",
    key: "Account",
  },
  {
    label: "Insta ID",
    key: "instaId",
  },
  {
    label: "Facebook ID",
    key: "fbId",
  },
  {
    label: "Linkedin ID",
    key: "linkindId",
  },
  {
    label: "Status",
    key: "status",
  },
];
